(() => {
  if (window.cottonilInteractionTrackingLoaded) return;
  window.cottonilInteractionTrackingLoaded = true;
  const ctx = document.getElementById('cottonil-analytics-context');
  if (!ctx) return;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function publish(event_name, parameters = {}) {
    if (!allowed() || !window.Shopify?.analytics?.publish) return;
    try { const p = Shopify.analytics.publish('cottonil:interaction', { event_name, page_type: ctx.dataset.pageType, currency: ctx.dataset.currency, ...parameters }); p?.catch?.(() => {}); } catch {}
  }
  function productItem(element, variantId) {
    const scope = element.closest('article') || ctx;
    const selected = variantId || (scope === ctx ? document.querySelector('.cp-product [name="id"]')?.value : null);
    const node = selected && /^\d+$/.test(selected) ? scope.querySelector('[data-variant-id="' + selected + '"]') : scope.querySelector('[data-cottonil-item]');
    if (!node) return null;
    const d = node.dataset;
    const result = { item_id: d.itemId, item_name: d.itemName, item_brand: d.itemBrand, item_category: d.itemCategory, item_variant: d.itemVariant, variant_id: d.variantId, sku: d.sku, price: Number(d.price) };
    if (!Number.isFinite(result.price)) delete result.price;
    return result;
  }
  const component = el => el.closest('.cc-card') ? 'collection_card' : el.closest('.rf-product') ? 'home_card' : el.closest('.cp-product') ? 'product_page' : el.closest('footer,.rf-footer') ? 'footer' : 'navigation';
  const options = document.querySelector('.cp-product .product-options--root');
  if (options?.dataset.id) window.addEventListener('theme:product:' + options.dataset.id + ':variantChanged', event => {
    const variant = event.detail?.variant;
    if (!variant?.id) return;
    const item = productItem(options, String(variant.id));
    if (item) publish(variant.available === false ? 'unavailable_variant_selected' : 'variant_selected', { component: 'product_page', items: [item] });
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const favorite = target.closest('.rf-favorite,.cc-favorite,.cp-favorite');
    if (favorite) {
      const was = favorite.getAttribute('aria-pressed');
      requestAnimationFrame(() => {
        const now = favorite.getAttribute('aria-pressed');
        const item = productItem(favorite);
        if (item && now !== was) publish(now === 'true' ? 'add_to_wishlist' : 'remove_from_wishlist', { component: component(favorite), items: [item] });
      });
      return;
    }
    const link = target.closest('a[href]');
    const size = target.closest('.product-size-chart--link');
    if (size) publish('size_guide_view', { component: 'product_page' });
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.origin); } catch { return; }
    if (link.matches('[data-cc-more]')) { publish('load_more_click', { component: 'collection_grid' }); return; }
    if (/^tel:|^mailto:/.test(url.protocol) || /^(wa.me|api.whatsapp.com)$/.test(url.hostname)) {
      publish('contact_click', { interaction_type: url.protocol === 'tel:' ? 'phone' : url.protocol === 'mailto:' ? 'email' : 'whatsapp', component: component(link) }); return;
    }
    if (url.origin !== location.origin) return;
    let path; try { path = decodeURIComponent(url.pathname); } catch { path = url.pathname; }
    if (/جدول-المقاسات|size-guide|size-chart/i.test(path)) { if (!size) publish('size_guide_view', { component: component(link) }); return; }
    if (/\/products\//.test(path)) {
      const item = productItem(link);
      if (item) {
        const variant = url.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant) && variant !== item.variant_id) {
          item.item_id = item.item_id.replace(/_\d+$/, '_' + variant); item.variant_id = variant;
          delete item.item_variant; delete item.price; delete item.sku;
        }
        publish('select_item', { items: [item], component: component(link) });
      }
    } else if (/\/pages\/contact|تواصل/.test(path)) publish('contact_click', { interaction_type: 'contact_page', component: component(link) });
    else if (link.closest('nav,.rf-nav,.rf-header')) publish('navigation_click', { component: 'navigation', interaction_type: path.split('/')[1] || 'home' });
  }, true);
  document.addEventListener('change', event => {
    const target = event.target;
    if (target instanceof HTMLSelectElement && target.name === 'sort_by') publish('sort_products', { component: 'collection_toolbar', sort_order: target.value });
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.closest('.cc-filters')) {
      const active = Array.from(form.elements).filter(e => e.name?.startsWith('filter.') && !e.disabled && (e.type !== 'checkbox' || e.checked));
      publish('filter_apply', { component: 'collection_filters', filter_name: active.length === 1 ? active[0].name : 'multiple' });
    }
    if (/newsletter/i.test(form.id)) publish('newsletter_submit', { component: 'newsletter', interaction_type: 'submission_attempt' });
  }, true);
  let errors = 0;
  const reportError = type => { if (errors++ < 3) publish('site_error', { component: 'storefront', error_type: type }); };
  window.addEventListener('error', e => { if (e.error) reportError(['TypeError', 'ReferenceError', 'SyntaxError', 'RangeError'].includes(e.error.name) ? e.error.name : 'script_error'); });
  window.addEventListener('unhandledrejection', () => reportError('unhandled_promise'));
  let searchReported = false;
  function searchResults() { if (!searchReported && allowed() && ctx.dataset.pageType === 'search') { const count = Number(ctx.dataset.resultsCount); if (Number.isInteger(count) && count >= 0) { searchReported = true; publish(count === 0 ? 'search_no_results' : 'search_results_viewed', { component: 'search', results_count: count }); } } }
  let pageReported = false;
  function specialPage() {
    if (pageReported || !allowed()) return;
    let path; try { path = decodeURIComponent(location.pathname); } catch { return; }
    if (ctx.dataset.pageType === '404') { pageReported = true; publish('page_not_found', { component: 'storefront' }); }
    else if (/^\/(policies\/|pages\/(الشحن-والتسليم|سياسة-الارجاع))/.test(path)) { pageReported = true; publish('policy_viewed', { component: 'policy_page' }); }
  }
  searchResults();
  specialPage();
  document.addEventListener('visitorConsentCollected', searchResults);
  document.addEventListener('visitorConsentCollected', specialPage);
})();
